export default __webpack_public_path__ + "static/media/tarra-h2h-logotype-l.b13d687f.svg";